import { useSearchParams } from "react-router-dom";
import dayjs from "../dayjs";
import { startOfPreviousMonth } from "../misc/dateUtils";
import type { ECommerceSearchCriteria } from "./ECommerceSearch";

export const useECommerceSearch = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const query = searchParams.get("query") ?? "";
  const monthParam = searchParams.get("month");
  const month = monthParam ? dayjs(monthParam, "YYYY-MM") : startOfPreviousMonth();
  const tagsParam = searchParams.get("tags") ?? "";
  const tags = tagsParam
    .split(",")
    .filter((t) => t.length > 0 && t.includes("::"))
    .map((t) => ({ category: t.split("::")[0], value: t.split("::")[1] }));

  const setSearchCriteria = ({ text, month, tags }: ECommerceSearchCriteria) =>
    setSearchParams((prev) => {
      [
        { key: "query", value: text },
        { key: "month", value: month?.format("YYYY-MM") },
        { key: "tags", value: tags.map(({ category, value }) => `${category}::${value}`)?.join(",") },
      ].forEach(({ key, value }) => {
        if (value) {
          prev.set(key, value);
        } else {
          prev.delete(key);
        }
      });
      return prev;
    });

  const clear = () => setSearchParams(new URLSearchParams());

  return {
    searchCriteria: {
      text: query,
      month,
      tags,
    },
    setSearchCriteria,
    clear,
  };
};
